import { useCanonicalUrl } from '@otovo/shared/components/Head/useCanonicalUrl';
import { useGlobalConfig } from '@otovo/shared/hooks/configContext';
import { getSanityClient } from '@otovo/shared/lib/sanity/sanityClient';
import { Sanity$BlogPage } from '@otovo/shared/types/sanityTypes';
import { useNextSanityImage } from 'next-sanity-image';

export function usePostJsonLd(sanityDocument: Sanity$BlogPage) {
  const config = useGlobalConfig();
  const sanityClient = getSanityClient();
  const postImageProps = useNextSanityImage(
    sanityClient,
    sanityDocument.mainImage,
  );
  const authorImageProps = useNextSanityImage(
    sanityClient,
    sanityDocument.author.mainImage,
  );

  let canonicalURL = useCanonicalUrl();

  if (sanityDocument.meta.canonicalURLOverride) {
    canonicalURL = sanityDocument.meta.canonicalURLOverride;
  }

  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    publisher: {
      '@type': 'Organization',
      name: 'Otovo',
      url: `${config.STOREFRONT_URL}/blog/`,
    },
    author: {
      '@type': 'Person',
      name: sanityDocument.author.name,
      image: authorImageProps
        ? {
            '@type': 'ImageObject',
            url: authorImageProps.src,
            width: authorImageProps.width,
            height: authorImageProps.height,
          }
        : {},
      url: `${config.STOREFRONT_URL}/blog/author/${sanityDocument.author.slug.current}/`,
    },
    headline: sanityDocument.title,
    url: canonicalURL,
    datePublished: sanityDocument._publishedAt,
    dateModified: sanityDocument._updatedAt,
    description: sanityDocument.meta.metaDescription,
    mainEntityOfPage: canonicalURL,
    image: {
      '@type': 'ImageObject',
      url: postImageProps.src,
      width: postImageProps.width,
      height: postImageProps.height,
    },
  };
}
